(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-bottom-bar')) {
    customElements.define(
      'newsletter-bottom-bar',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('fixed-bottom')) return;

          const panel = this.querySelector('.apps-bottom-panel');
          if (!panel) return;

          this.observer?.disconnect();

          const updateHeight = () => {
            this.style.height = `${panel.getBoundingClientRect().height}px`;
          };

          this.observer = new ResizeObserver(updateHeight);
          this.observer.observe(panel);
          updateHeight();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
